import { useEffect, useRef } from 'react';
import ReactDOM from 'react-dom';

interface PortalProps {
	children: React.ReactNode;
}

const Portal = ({ children }: PortalProps) => {
	const elRef = useRef<HTMLDivElement | null>(null);
	if (!elRef.current) {
		elRef.current = document.createElement('div');
	}

	useEffect(() => {
		const el = elRef.current!;
		document.body.appendChild(el);
		return () => {
			document.body.removeChild(el);
		};
	}, []);

	return ReactDOM.createPortal(children, elRef.current);
};

export default Portal;
